import type { Question } from '@/domain/question'
import type { QuizRepository } from '@/repositories/QuizRepository'
import { seedQuestions } from '@/data/seed/questions'

// Not consumed by any P0 screen — present so P1's Quiz Engine has a working
// implementation to build against on day one (Document 11 §11).
export class LocalQuizRepository implements QuizRepository {
  async getQuestionsForEpisode(episodeId: string): Promise<Question[]> {
    return seedQuestions.filter((q) => q.episodeId === episodeId)
  }
}
